import React from 'react';
import { Table } from 'react-bootstrap';
import { BsThreeDots } from 'react-icons/bs';
import ChangeRequestTable from '../components/ChangeRequestTable';
import { useData } from '../context/DataContext';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import {
  getCoachChangeReasons,
  getNavigatorChangeReasons,
} from '../config/url';

const ChangeRequest = () => {
  const navigatorData = useFetchData(getNavigatorChangeReasons, config);
  const coachData = useFetchData(getCoachChangeReasons, config);

  return (
    <div className='container p-2 my-4'>
      <h3>Change Requests</h3>

      <div>
        <h5 className='text-secondary my-3'>Health Navigators</h5>
        {navigatorData != null ? (
          <ChangeRequestTable data={navigatorData}></ChangeRequestTable>
        ) : (
          <h4 className='my-4'>Fetching data...</h4>
        )}
      </div>

      <div>
        <h5 className='text-secondary my-3'>Health Coaches</h5>
        {coachData != null ? (
          <ChangeRequestTable data={coachData}></ChangeRequestTable>
        ) : (
          <h4 className='my-4'>Fetching data...</h4>
        )}
      </div>
    </div>
  );
};

export default ChangeRequest;
